"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderGroupToJSON = exports.OrderGroupFromJSONTyped = exports.OrderGroupFromJSON = exports.instanceOfOrderGroup = exports.OrderGroupProductTypeEnum = void 0;
var runtime_1 = require("../runtime");
var OrderGroupMeta_1 = require("./OrderGroupMeta");
var TestSelection_1 = require("./TestSelection");
/**
 * @export
 */
exports.OrderGroupProductTypeEnum = {
    Diagnostic: 'Diagnostic',
    DiagnosticRna: 'DiagnosticRna',
    Proactive: 'Proactive',
    Nips: 'NIPS',
    Carrier: 'Carrier',
    Exome: 'Exome',
    StatTat: 'StatTat',
    SmaStatTat: 'SmaStatTat',
    AfpAcheSendout: 'AfpAcheSendout',
    CellCulture: 'CellCulture',
    DevelopmentalDisordersCyto: 'DevelopmentalDisordersCyto',
    DevelopmentalDisordersCytoParentalFollowUp: 'DevelopmentalDisordersCytoParentalFollowUp',
    FragileXDiagnostic: 'FragileXDiagnostic',
    FragileXSyndromeSendout: 'FragileXSyndromeSendout',
    HelixPreventive: 'HelixPreventive',
    MaternalCellContamination: 'MaternalCellContamination',
    PregnancyLossCyto: 'PregnancyLossCyto',
    PregnancyLossCytogeneticsParentalFollowUp: 'PregnancyLossCytogeneticsParentalFollowUp',
    PrenatalDiagnosisCytogenetics: 'PrenatalDiagnosisCytogenetics',
    PrenatalDiagnosisCytogeneticsParentalFollowUp: 'PrenatalDiagnosisCytogeneticsParentalFollowUp',
    RecurrentPregnancyLossOrInfertilityCyto: 'RecurrentPregnancyLossOrInfertilityCyto',
    WholeGenomeSequencing: 'WholeGenomeSequencing',
    Pgx: 'PGx',
    Ihc: 'IHC',
    TumorFusionProfile: 'TumorFusionProfile',
    MrdMonitoring: 'MRDMonitoring',
    MrdBaseline: 'MRDBaseline',
    TherapySelection: 'TherapySelection',
    TherapySelectionIhc: 'TherapySelectionIHC',
    Unknown: 'Unknown'
};
/**
 * Check if a given object implements the OrderGroup interface.
 */
function instanceOfOrderGroup(value) {
    var isInstance = true;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "productType" in value;
    isInstance = isInstance && "testSelections" in value;
    isInstance = isInstance && "rereqSetCode" in value;
    return isInstance;
}
exports.instanceOfOrderGroup = instanceOfOrderGroup;
function OrderGroupFromJSON(json) {
    return OrderGroupFromJSONTyped(json, false);
}
exports.OrderGroupFromJSON = OrderGroupFromJSON;
function OrderGroupFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'meta': (0, OrderGroupMeta_1.OrderGroupMetaFromJSON)(json['meta']),
        'productType': json['productType'],
        'sampleType': !(0, runtime_1.exists)(json, 'sampleType') ? undefined : json['sampleType'],
        'alternateSampleTypes': !(0, runtime_1.exists)(json, 'alternateSampleTypes') ? undefined : json['alternateSampleTypes'],
        'testSelections': (json['testSelections'].map(TestSelection_1.TestSelectionFromJSON)),
        'turnaroundTime': !(0, runtime_1.exists)(json, 'turnaroundTime') ? undefined : json['turnaroundTime'],
        'commercialArea': !(0, runtime_1.exists)(json, 'commercialArea') ? undefined : json['commercialArea'],
        'rereqSetCode': json['rereqSetCode'],
    };
}
exports.OrderGroupFromJSONTyped = OrderGroupFromJSONTyped;
function OrderGroupToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'meta': (0, OrderGroupMeta_1.OrderGroupMetaToJSON)(value.meta),
        'productType': value.productType,
        'sampleType': value.sampleType,
        'alternateSampleTypes': value.alternateSampleTypes,
        'testSelections': (value.testSelections.map(TestSelection_1.TestSelectionToJSON)),
        'turnaroundTime': value.turnaroundTime,
        'commercialArea': value.commercialArea,
        'rereqSetCode': value.rereqSetCode,
    };
}
exports.OrderGroupToJSON = OrderGroupToJSON;
